import * as bootstrap from 'bootstrap'
import * as map from "./mapping.js";
import * as utilities from "./utilities.js";

import elements from './elements/index.js';
import charts from "./charts/index.js";
import data_processing from "./data_processing/index.js";

(async () => {
    try {
        await window.i18nReady;
        
        // Obtain update_time
        const update_time = await data_processing.update_time.get_update_time();
        utilities.update_update_time_display(update_time);

        // Load the Daily Stats Data
        const update_month = update_time.slice(0,7);
        let stats_data = await utilities.load_daily_stats_data(update_month);
        // Init elements
        await generate_top_data(stats_data);
        set_first_column_active();
        initialize_carousel();
        await elements.cards.main_card(stats_data);

        // Hide the loading overlay
        elements.spinner.hideSpinner("loadingOverlay");
    } catch (error) {
        console.log(error)
    }
})();

async function generate_top_data(stats_data) {
    for (let column in map.dataset_all_mapping) {
        let count_method = 'count';
        if (column === 'resources_formats') {
            count_method = 'presence';
        }
        await charts.progress_bar.generate_progress_bar_carousel_item(stats_data, 'test', column, count_method, map.dataset_all_mapping);
    }
}

function set_first_column_active() {
    const first_col_id = 'top_' + Object.keys(map.dataset_all_mapping)[0] + '_item';
    const first_col = document.getElementById(first_col_id);
    first_col.classList.add('active');
}

function initialize_carousel() {
    const myCarouselElement = document.querySelector('#top_data_carousel');
    const carousel = new bootstrap.Carousel(myCarouselElement, {
        interval: 2000,
        touch: false
    });
}